import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/apps/assets/images/pdfBackground.png'


const _withScopeId = n => (_pushScopeId("data-v-6b14f9f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dental-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "dental-card__background",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "dental-card__wrapper" }

import {
  AppointmentType,
  ObservationHistoryType,
  ResultAnalyzesType,
} from '@/shared/types'
import { computed } from 'vue'
import Schedule from './components/Schedule.vue'
import PlaqueCondition from './components/PlaqueCondition.vue'
import Observation from './components/Observation.vue'
import { PlaqueReportController } from '@/pages/PlaqueReportPage/plaqueReport'

interface Props {
  resultAnalyzes: ResultAnalyzesType
  appointments: AppointmentType
  plaqueReportController: PlaqueReportController
  observationHistory: ObservationHistoryType[]
}


export default /*#__PURE__*/_defineComponent({
  props: {
    resultAnalyzes: null,
    appointments: null,
    plaqueReportController: null,
    observationHistory: null
  },
  setup(__props: any) {

const props = __props as {
  resultAnalyzes: ResultAnalyzesType
  appointments: AppointmentType
  plaqueReportController: PlaqueReportController
  observationHistory: ObservationHistoryType[]
}



const totalPlaque = computed<number>(() => {
  return props.resultAnalyzes.index.day + props.resultAnalyzes.index.long
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Observation, {
        "plaque-report-controller": __props.plaqueReportController,
        appointments: __props.appointments,
        "observation-history": __props.observationHistory,
        "result-analyzes": __props.resultAnalyzes,
        "total-plaque": _unref(totalPlaque)
      }, null, 8, ["plaque-report-controller", "appointments", "observation-history", "result-analyzes", "total-plaque"]),
      _createVNode(PlaqueCondition, {
        "total-plaque": _unref(totalPlaque),
        class: "dental-card__plaque-condition"
      }, null, 8, ["total-plaque"]),
      _createVNode(Schedule, {
        "plaque-report-controller": __props.plaqueReportController,
        appointments: __props.appointments,
        class: "dental-card__schedule"
      }, null, 8, ["plaque-report-controller", "appointments"])
    ])
  ]))
}
}

})